import { Sparkles } from 'lucide-react';
import { useAiAssistantPanelOptional } from '../context/aiAssistantPanelContext';

/**
 * Header entry point for the assistant.
 *
 * Optional-context hook on purpose: ExecutiveAppHeader is shared by layouts,
 * and one that has not mounted AiAssistantProvider should render nothing rather
 * than crash the whole header.
 */
export function AiAssistantButton({ className = '' }) {
    const panel = useAiAssistantPanelOptional();
    if (!panel) return null;

    return (
        <button
            type="button"
            onClick={() => panel.togglePanel()}
            aria-label="Ask Mela"
            title="Ask Mela"
            className={`relative flex h-9 w-9 items-center justify-center rounded-lg border border-primary-700/70 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground ${className}`}
        >
            <Sparkles className="h-4 w-4" aria-hidden="true" />
        </button>
    );
}

export default AiAssistantButton;
